import { render, staticRenderFns } from "./detail-ldb.vue?vue&type=template&id=7c9f16ea&scoped=true&"
import script from "./detail-ldb.vue?vue&type=script&lang=js&"
export * from "./detail-ldb.vue?vue&type=script&lang=js&"
import style0 from "./detail-ldb.vue?vue&type=style&index=0&id=7c9f16ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f16ea",
  null
  
)

export default component.exports